export default "__VITE_ASSET__BG3OkPCQ__"